import { registerPlugin } from '@capacitor/core';
import { isAndroid, isNativePlatform } from './platformService.js';

const PlayBilling = registerPlugin('PlayBilling');

export function canUsePlayBilling() {
  return isNativePlatform() && isAndroid();
}

export async function purchaseSubscription({
  productId,
  basePlanId,
  offerId = null,
  obfuscatedAccountId = null,
}) {
  if (!canUsePlayBilling()) {
    throw new Error('Google Play Billing is available only in the Android app.');
  }

  return PlayBilling.purchaseSubscription({
    productId,
    basePlanId,
    offerId,
    obfuscatedAccountId,
  });
}

export async function queryActiveSubscriptions() {
  if (!canUsePlayBilling()) return { purchases: [] };
  return PlayBilling.queryActiveSubscriptions();
}
